import { setMapOpen } from '@/features/map-component/mapComponentActions';
import {
  isMapLoadedSelector,
  isMapOpenSelector,
  mapJourneySelector,
} from '@/features/map-component/mapComponentSelectors';
import { TransText } from '@/i18n/trans/text';
import { useDispatch, useSelector } from '@/store/utils';
import { format } from '@/utils/dateTime';
import { Dialog, Loadable } from '@fleet/webshop-ui';
import { lazy, Suspense, useMemo } from 'react';

const MapComponent = lazy(() => import('./MapComponent'));

export const MapModal = () => {
  const dispatch = useDispatch();
  const isMapOpen = useSelector(isMapOpenSelector);
  const isMapLoaded = useSelector(isMapLoadedSelector);
  const journey = useSelector(mapJourneySelector);

  const dialogTitle = useMemo(() => {
    if (!journey) {
      return;
    }
    return [
      journey.departureTime && format(journey.departureTime, 'HH:mm'),
      journey.arrivalTime && format(journey.arrivalTime, 'HH:mm'),
      journey.originStop?.name,
      journey.destinationStop?.name,
    ]
      .filter(Boolean)
      .join(' - ');
  }, [journey]);

  return (
    <Dialog
      className={{
        root: 'h-[80vh] w-[80vw] max-w-none overflow-hidden [&>section]:flex [&>section]:h-full [&>section]:flex-col',
        content: 'flex-1 p-0',
      }}
      data-testid="map-component-modal"
      headerTitle={dialogTitle ?? <TransText i18nKey="journeyMap" />}
      isOpen={isMapOpen}
      onOpenChange={(open) => dispatch(setMapOpen(open))}
    >
      <Loadable loading={!isMapLoaded} overlay={true}>
        <Suspense fallback={null}>
          <MapComponent />
        </Suspense>
      </Loadable>
    </Dialog>
  );
};
